exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-toolbar {\n\twidth: 100%;\n}\n\nhtml.flexbox .action-toolbar {\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\nhtml.no-flexbox .action-toolbar {\n\ttext-align: center;\n}\n\n.action-toolbar-item {\n\tbackground: transparent;\n\tborder: 0;\n\tdisplay: inline-block;\n\tmargin: 20px auto 0 auto;\n\ttext-align: center;\n\ttext-decoration: none !important;\n}\n\n.action-toolbar-icon i {\n\tfont-size: 24px !important;\n}\n\n.action-toolbar-text {\n\tmargin-top: 5px;\n\ttext-transform: uppercase;\n\tfont-weight: 600;\n}\n", ""]);

// exports
